import '../../../common/css/base.scss';
import '../css/index.scss';
import '../../../common/js/amap-debug'; // 此文件引用需要置顶，否则mock的时候会有问题
import Vue from 'vue';
import amapApp from '@ali/amap-lib';
import App from '../components/App.vue';
import ACTDATA from '../../../config/config.act';

console.log(`是否公网环境${amapApp.webviewInfo.isPublic()}`);
Vue.config.productionTip = false;
Vue.config.devtools = !amapApp.webviewInfo.isPublic();
// const isInAmap = amapApp.webviewInfo.isInAmap();
/* eslint-disable no-new */
amapApp.bridge.ready((res) => {
  // 埋点
  amapApp.log.initLog(`${ACTDATA.name}`, 1);
  Vue.config.errorHandler = (error, vm, msg) => {
    console.error(error, vm, msg);// 在控制台打出错误
  };
  const isInAmap = !!(res && res.tid);
  new Vue({
    el: '#app',
    data: { appInfo: res, isInAmap },
    render: (h) => h(App)
  });
});
